import { Component, OnInit } from '@angular/core';
import { LoaderService } from 'src/app/core/services/loader.service';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.scss']
})
export class LoaderComponent implements OnInit {

  isLoading: Subject<boolean> = this.loaderService.isLoading;
  boxes: Array<object> = [
    { divs: [1, 2, 3, 4] },
    { divs: [1, 2, 3, 4] },
    { divs: [1, 2, 3, 4] },
    { divs: [1, 2, 3, 4] }
  ];
  constructor(private loaderService: LoaderService) { }

  ngOnInit() {
  }

}
